export { default as RegisterCreditCardForm } from './register-credit-card-form'
